module.exports = __webpack_public_path__ + "static/media/classicos_masculino_ate_400.82ac00a0.jpg";